export const TITLE: string = 'Test Vocacional';

export const WELCOME_TITLE: string = '¡BIENVENIDO 👋!';

export const DESCRIPTIONS: string[] = [
  `Este <strong>Test de Intereses y Preferencias Profesionales</strong> tiene como objetivo orientar la elección de los estudios y brindar opciones de carreras a partir de información precisa sobre las actividades que se realizan en diferentes campos profesionales.`,
  `<strong>RECUERDA:</strong> los test vocacionales, solo son un punto de partida en el proceso de la <strong>&lt;&lt;Elección de una carrera&gt;&gt;,</strong> nos da opciones, pero debes continuar con el proceso, buscando información sobre las carreras que te interesan, y tomándote el tiempo necesario para la reflexión personal que te permita tomar la mejor decisión.`
]

export const INSTRUCTIONS_TITLE: string = 'Instrucciones:';

export const INTRUCTIONS: string[] = [
  `Lee cada afirmación y elige solo una opción.`,
  `Resuelve el test de la manera más espontánea posible, sin detenerte demasiado.`,
  `Evita distracciones, y resuelve el test solo, no necesitas ayuda.`,
  `Sé muy sincero(a) al contestar, recuerda: «No hay respuestas malas, todas son correctas».`,
  `Al terminar de contestar todas las preguntas, recuerda registrarte, llenando correctamente tus datos para poder descargar tus resultados.`
]

export const TITLELEGEND: string = 'PARA RESPONDER TEN EN CUENTA LO SIGUIENTE: 📝';

export const LEGENDS: {
  id: number;
  value: string;
  emoji?: string;
  description?: string;
}[] = [
    {
      id: 0,
      value: '0',
      emoji: '🤔',
      description: 'No Conozco'
    },
    {
      id: 1,
      value: '1',
      emoji: '😒',
      description: 'Me Desagrada'
    },
    {
      id: 2,
      value: '2',
      emoji: '😐',
      description: 'Neutral'
    },
    {
      id: 3,
      value: '3',
      emoji: '😊',
      description: 'Me Agrada'
    }
  ]

export const REGISTER_TITLE: string = 'Regístrate';

export const REGISTER_DESCRIPTION: string = 'Para poder obtener los resultados del test de <strong>Intereses y Preferencias Profesionales</strong> que acabas de realizar, necesitamos que llenes el siguiente formulario correctamente:';

export const REGISTER_ACCEPT_BEFORE: string = 'Al hacer clic en «Continuar» reconozco que he leído y acepto'

export const REGISTER_ACCEPT_LINK: string = 'https://consultoriomga.com/politica-de-proteccion-de-datos-personales-mga/'

export const REGISTER_ACCEPT: string = 'la Política de protección de datos personales de Consultoriomga.com'

export const REGISTER_ACCEPT_AFTER = ', y otorgo consentimiento libre, expreso, inequívoco e informado, para que Consultorio Psicológico MGA puedan contactar o enviarme información de acuerdo a ley.'

export const REGISTER_IMPORTANT: string = 'Importante:';

export const REGISTER_IMPORTANT_DESCRIPTION: string = 'Si no estás de acuerdo con lo expuesto, debes abstenerte de registrarte.';

export const REGISTER_BUTTON: string = 'Continuar';

export const LOADING_BUTTON: string = 'Cargando...';

export const VALIDATION_BUTTON: string = 'Validar'

export const SEND_CODE_SMS: string = 'Enviar código al celular ';

export const SEND_CODE_EMAIL: string = 'Enviar código al correo ';


export const RESULT_TITLE: string = 'Gracias por participar en el proceso';

export const RESULT_DESCRIPTION = (name: string) => `Felicitaciones <strong>${name}</strong> acabas de finalizar el <strong>test de intereses y preferencias profesionales</strong> con éxito, tus respuestas fueron grabadas satisfactoriamente.`;

export const CONSULTORIO_MGA: string = '<strong>Consultorio Psicológico MGA.</strong>';

export const RESULT_HIGH_TITLE: string = 'A nivel <strong>“alto”</strong> interés en el:';

export const RESULT_MEDIUM_TITLE: string = 'A nivel <strong>“medio”</strong> interés en el:';

export const RESULT_EMPTY: string = 'No se encontraron resultados';

export const RESULT_GRATITUDE_TITLE: string = '¡Gracias por participar!';

//export const RESULT_GRATITUDE_DESCRIPTION: string = 'Si deseas conocer más sobre tu perfil vocacional, puedes descargar el reporte completo en PDF.';
export const RESULT_GRATITUDE_DESCRIPTION: string = 'No olvides descargar tus resultados completos en PDF.';

export const RESULT_GRATITUDE_DOWNLOAD: string = 'Descargar PDF';

export const RESULT_GRATITUDE_BACK: string = 'Volver al inicio';

export const LINK: string = 'https://consultoriomga.com/test-vocacional/';